import React from 'react';
import styled from 'styled-components';

import { Icon } from './_base';

const MadeInNewYorkBadgeSVG = styled(Icon).attrs({ viewBox: '0 0 40.2 39.8' })`
    width: 1.0100502513em;
`;

function MadeInNewYorkBadge({ color = 'currentColor', ...props }) {
    return (
        <MadeInNewYorkBadgeSVG
            data-test="icon-made-in-new-york"
            {...props}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g fill={color}>
                <path d="M39.3 19.9c0 10.8-8.8 19.6-19.8 19.4C9 39.1.4 30.6.5 19.8.6 9 9.3.3 20.2.5c10.6.1 19.1 8.7 19.1 19.4zm-1.4 0C37.9 10 30 2 20.2 1.9 10.1 1.8 2 9.9 2 19.8c0 10 8 17.9 17.7 18 10 .2 18.2-7.9 18.2-17.9z" />
                <path d="M35.9 2.3c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8-1.8-.8-1.8-1.8.8-1.8 1.8-1.8zm-.1 3.3c.8 0 1.5-.6 1.5-1.4 0-.8-.6-1.5-1.4-1.5s-1.5.6-1.5 1.4c0 .8.6 1.5 1.4 1.5zM20.2 31.9h-1.9c-2.5-3.2-5.1-6.5-7.7-9.8v9.8H8.7V19h1.9c2.5 3.2 5.1 6.5 7.6 9.7h.1V19h1.9v12.9zm8.9 0h-1.9v-5.3c0-.2-.1-.4-.2-.6-1.6-2.3-3.2-4.6-4.9-6.9 0-.1-.1-.1-.1-.2h2.3c1.3 1.8 2.6 3.6 3.9 5.5 1.3-1.8 2.6-3.7 3.9-5.5h2.4c-.1.1-.1.1-.1.2-1.7 2.3-3.4 4.6-5 6.9-.1.2-.2.3-.2.5v5c-.1.2-.1.3-.1.4zM10.6 9.6c.4.6.8 1.2 1.3 1.9-.2.1-.4.3-.6.4-.7-1-1.4-2-2.1-3.1.2-.1.4-.3.6-.4.7.3 1.4.5 2.1.8V7c.2-.2.4-.3.6-.4.7 1 1.4 2 2.1 3.1-.2 0-.4.2-.6.3-.4-.6-.9-1.2-1.3-1.9h-.1v2.2c-.7-.2-1.3-.5-2-.7zm10.3-1.1c.3-1.2.5-2.4.8-3.6.2 0 .4.1.6.1.5.1.9.2 1.4.3.7.2 1.2.5 1.4 1.3.1.7 0 1.3-.5 1.9-.4.4-.9.6-1.4.5-.7-.1-1.5-.3-2.3-.5zm.9-.6c.5.1.8.2 1.2.3h.7c.5-.1.7-.5.8-1.1 0-.4-.1-.7-.5-.9-.5-.2-1.1-.3-1.6-.4l-.6 2.1zm1.3 8h-.7c-.6-.8-1.3-1.6-2-2.4v2.4h-.7v-3.6h.7c.6.8 1.3 1.6 1.9 2.4v-2.3h.7c.1 1 .1 2.2.1 3.5zm2.8-5.9L28 7c.9.6 1.8 1.3 2.7 1.9-.2.2-.3.4-.4.6-.7-.5-1.3-1-2-1.5-.1.2-.2.3-.4.5.4.3.7.5 1.1.8-.1.2-.3.4-.4.6-.4-.3-.7-.5-1.1-.8-.2.2-.3.4-.4.6l2.1 1.5c-.2.2-.3.4-.4.6-1-.5-2-1.1-2.9-1.8zm-9.3-4.8c.3-.1.6-.1 1-.2L20 8.3c-.3.1-.6.1-.9.2-.2-.2-.3-.5-.5-.7-.6.2-1.3.3-2.1.4-.1.3-.2.5-.2.8-.3 0-.5.1-.9.2.4-1.4.8-2.7 1.2-4zm1.5 1.9c-.3-.4-.6-.8-.9-1.3-.2.5-.3 1-.4 1.5.4 0 .9-.1 1.3-.2zM17 12.2h.7v3.6H17v-3.6z" />
                <path d="M36.1 4.3c.2.3.4.5.6.8h-.4c-.3-.3-.3-.9-.9-.8v.8h-.3V3.2c.4 0 .7 0 1.1.1.2 0 .3.2.4.4 0 .2-.1.4-.3.5-.1 0-.1 0-.2.1zm-.7-.8v.6c.2-.1.4-.1.6-.1.1 0 .2-.1.2-.2s-.1-.2-.2-.3h-.6z" />
            </g>
        </MadeInNewYorkBadgeSVG>
    );
}

export {
    MadeInNewYorkBadge as default,
    MadeInNewYorkBadge,
};
